import { cn } from "@/utils/cn";

type CartBadgeProps = {
  isShareable: boolean;
  cartId?: string | null;
  cartName?: string | null;
  rounded?: boolean;
};

export default function CartBadge({
  isShareable,
  cartId,
  cartName,
  rounded = false,
}: CartBadgeProps) {
  return (
    <div
      className={cn(
        "flex items-center gap-2 rounded-lg px-3 py-2",
        rounded && "gap-3 rounded-full border border-[#90D9D9] px-4",
        isShareable ? "bg-[#E8F7F7]" : "border border-[#C1332A] bg-[#C1332A18]"
      )}
    >
      {rounded ? (
        <span
          className={`text-md font-semibold transition-colors ${isShareable ? "text-[#246B6B]" : "text-[#C1332A]"}`}
        >
          Cart
        </span>
      ) : (
        <span
          className={cn(
            "inline-block size-2 shrink-0 rounded-full",
            isShareable ? "bg-[#489B9B]" : "bg-[#C1332A]"
          )}
        />
      )}
      <div className="min-w-0">
        <p
          className={`truncate text-[#191919] ${rounded ? "text-md font-semibold leading-tight" : "text-sm leading-[1.25]"}`}
        >
          {cartName || "Admin Master Cart"}
        </p>
        <p className="truncate text-xs leading-[1.25] text-[#191919]">
          {cartId || "—"}
        </p>
      </div>
    </div>
  );
}
